import { Component } from '@angular/core';
import { AppService } from '@services/app.service';

@Component({
  selector: 'app-user-home',
  // standalone: true,
  // imports: [],
  templateUrl: './user-home.component.html',
  styleUrl: './user-home.component.scss'
})
export class UserHomeComponent {
  constructor(
    private appService: AppService
  ){}

  logout(){
    this.appService.logout();
  }
}
